import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  id: "top-div"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_6 = {
  class: "container-fluid",
  id: "mid-div"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-10" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "row",
      id: "global"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-sm-8",
        id: "global-text"
      }, [
        /*#__PURE__*/_createElementVNode("h2", null, " FINDIT SMART GLOBAL JOURNEY "),
        /*#__PURE__*/_createElementVNode("p", null, "Keep it Simple Smart philosophy, an everyday lifestyle tool for Tourism, Professionals, Trades and Services. Tourism verticals EAT-SLEEP-SEE-DO industries for local, regional, interstate, places and venues organising day trips, weekend getaways, annual holidays and business travel. FindIt Smart Tourism sector 16 Categories of; Accommodation, Activities, Adventure, Antiques, Attraction, Culture, Dining, Eatery, Entertainment, Landmarks, Leisure, Recreation, Shopping, Tours, Wellbeing, Wineries, in planning trips, being ideal for busy people on the go searching directly on smartphones, iPads, laptops or desktops to optimise experiences."),
        /*#__PURE__*/_createElementVNode("p", null, "FindIt Smart Global unique online platform “Easy to find... Simple to use” philosophy can take you anywhere you choose Travel, Dining, Lifestyle or Adventure, finds a business in 30 seconds or creates an itinerary in 90 seconds of 30 businesses. Smartphones are the most powerful tool on the planet 7.51 billion smartphones or 6.04 billion internet users, 74% of the population use internet with 30% growth by 2029. Tourism industry’s 211 billion dollar annual turnover, 9.1 million international visitors travel to Australia."),
        /*#__PURE__*/_createElementVNode("p", null, "Previously owned Postcards Australia magazine in 2006-2021 had 15 years successful national brand, spin off from channel nine TV Show Postcards. Smart Discoveries Australia magazine exposes FindIt Smart business members into major hotel chains and boutique hotel and motel rooms across Australia. The FindIt Smart network is well- positioned to capture these markets with having all the regions, shire councils, all towns and suburbs. FindIt Smart places of interest enable users to find activities of; festivals, events, cellar doors, spa centres, waterfalls, lookouts, historic landmarks, searchable globally on FindIt Smart Global all in one platform network.")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-sm-4",
        id: "global-img"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-10",
    id: "destination-text"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, " FIND YOUR NEXT DESTINATION ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
], -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_11 = {
  class: "col-sm-10",
  id: "destinations"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "top-content" }
const _hoisted_14 = { class: "container-fluid" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/adelaide" }, "Adelaide")
], -1)
const _hoisted_18 = { class: "col" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/brisbane" }, "Brisbane")
], -1)
const _hoisted_21 = { class: "col" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/canberra" }, "Canberra")
], -1)
const _hoisted_24 = { class: "col" }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/darwin" }, "Darwin")
], -1)
const _hoisted_27 = { class: "col" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/hobart" }, "Hobart")
], -1)
const _hoisted_30 = { class: "col" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/melbourne" }, "Melbourne")
], -1)
const _hoisted_33 = { class: "col" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/perth" }, "Perth")
], -1)
const _hoisted_36 = { class: "col" }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "dest-text" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/page/sydney" }, "Sydney")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-10",
    id: "destination-text"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, " SECTORS ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
], -1)
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_42 = {
  class: "col-sm-10",
  id: "sectors",
  style: {"text-align":"center"}
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-sm-12" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = {
  class: "col-sm-3 col-lg-3 col-xl-3",
  id: "sector1"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "top-left" }, "Tourism", -1)
const _hoisted_49 = {
  class: "col-sm-3 col-lg-3 col-xl-3",
  id: "sector2"
}
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "top-left" }, "Professionals", -1)
const _hoisted_52 = {
  class: "col-sm-3 col-lg-3 col-xl-3",
  id: "sector3"
}
const _hoisted_53 = ["src"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "top-left" }, "Services", -1)
const _hoisted_55 = {
  class: "col-sm-3 col-lg-3 col-xl-3",
  id: "sector4"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "top-left" }, "Trades", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  id: "sector-topics"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-10",
    id: "destination-text"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, " SECTOR TOPICS ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "row",
      id: "sector-large"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-sm-10",
        id: "destination-text",
        style: {"border-bottom":"2px solid #dad4d4","margin-bottom":"20px"}
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "topic-heading active",
          href: "#"
        }, [
          /*#__PURE__*/_createTextVNode("Tourism "),
          /*#__PURE__*/_createElementVNode("div", {
            id: "line",
            style: {"width":"60px !important","margin-top":"10px !important"}
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "row",
      id: "sector-small"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
          /*#__PURE__*/_createElementVNode("div", { class: "col-sm-10" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
              /*#__PURE__*/_createElementVNode("button", {
                class: "dropbtn",
                onclick: "myFunction()"
              }, [
                /*#__PURE__*/_createTextVNode("Tourism "),
                /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("br")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-12",
  id: "tours"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "row",
        id: "topics"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/australian-treasures" }, "Australian Treasures")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/cultural-heritage-trails" }, "Cultural Heritage Trails")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/hiking-trails" }, "Hiking Trails")
          ]),
          /*#__PURE__*/_createElementVNode("p")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/historic-landmarks" }, "Historic Landmarks")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/lakes" }, "Lakes")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/lookouts" }, "Lookouts")
          ]),
          /*#__PURE__*/_createElementVNode("p")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/national-parks" }, "National Parks")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/natural-wonders" }, "Natural Wonders")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/rail-trails-cycling-tracks" }, "Rail Trails Cycling Tracks")
          ]),
          /*#__PURE__*/_createElementVNode("p")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/scenic-drives" }, "Scenic Drives")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/secret-hideaways" }, "Secret Hideaways")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/waterfalls-cascading-wonders" }, "Waterfalls Cascading Wonders")
          ]),
          /*#__PURE__*/_createElementVNode("p")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/waterways-walking-trails" }, "Waterways Walking Trails")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/wetlands-wonderlands" }, "Wetlands Wonderlands")
          ]),
          /*#__PURE__*/_createElementVNode("p"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("h3", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "/page/wildlife-experiences" }, "Wildlife Experiences")
          ]),
          /*#__PURE__*/_createElementVNode("p")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" })
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fis_header = _resolveComponent("fis-header")!
  const _component_home_search = _resolveComponent("home-search")!
  const _component_sponsors_page = _resolveComponent("sponsors-page")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_fis_footer = _resolveComponent("fis-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { style: {"overflow":"auto"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_fis_header),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.countries.length > 0)
              ? (_openBlock(), _createBlock(_component_home_search, {
                  key: 0,
                  countries: _ctx.countries
                }, null, 8, ["countries"]))
              : _createCommentVNode("", true),
            _hoisted_4,
            _createVNode(_component_sponsors_page, { style: {"margin-top":"-15px"} }),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_swiper, {
                      slidesPerView: 6,
                      spaceBetween: 10,
                      slidesPerGroup: 1,
                      loop: true,
                      loopFillGroupWithBlank: true,
                      pagination: false,
                      navigation: true,
                      breakpoints: _ctx.swiperOptions.breakpoints,
                      modules: _ctx.modules,
                      id: "home-swipe"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/VictoriaMonument_VictoriaSquare_4666_1768815016.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img1"
                              }, null, 8, _hoisted_16),
                              _hoisted_17
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/Brisbane_City_Skyline_Story_Bridge_4000_1768814832.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img2"
                              }, null, 8, _hoisted_19),
                              _hoisted_20
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/Canberra_cropped_6794_1759584032.JPG',
                                class: "img-fluid mx-auto d-block",
                                alt: "img3"
                              }, null, 8, _hoisted_22),
                              _hoisted_23
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/NT.ImageGallery_DiscoveringDarwinCity_Waterfront_0800_DNU_1769923716.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img4"
                              }, null, 8, _hoisted_25),
                              _hoisted_26
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/Hobart_7000_1768658825.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img4"
                              }, null, 8, _hoisted_28),
                              _hoisted_29
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/MelbourneCity_1724_1767869748.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img4"
                              }, null, 8, _hoisted_31),
                              _hoisted_32
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/equay_1768658487.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img4"
                              }, null, 8, _hoisted_34),
                              _hoisted_35
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("img", {
                                src: _ctx.storageBaseUrl + '/uploads/Discovering_Sydney_City_3462_1768132343.jpeg',
                                class: "img-fluid mx-auto d-block",
                                alt: "img4"
                              }, null, 8, _hoisted_37),
                              _hoisted_38
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["breakpoints", "modules"])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("img", { src: '/assets/images/Tourism.jpg' }, null, 8, _hoisted_47),
                      _hoisted_48
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("img", { src: '/assets/images/Professionals.jpg' }, null, 8, _hoisted_50),
                      _hoisted_51
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("img", { src: '/assets/images/Services.jpg' }, null, 8, _hoisted_53),
                      _hoisted_54
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("img", { src: '/assets/images/Trades.jpg' }, null, 8, _hoisted_56),
                      _hoisted_57
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_58
          ]),
          _hoisted_59,
          _hoisted_60
        ]),
        _createVNode(_component_fis_footer)
      ])
    ]),
    _: 1
  }))
}